import { CostComparisonManager } from "src/modules/CostComparisonManager/CostComparisonManager";

export const CostComparisonPage: React.FC = () => {
  return <CostComparisonManager />;
};
